export default "__VITE_ASSET__BCdg1WMm__"